import { UpdatePageLayout } from 'framework/ui/layout';
import { useNavigate } from 'react-router-dom';
import { Box, Grid2, Typography } from '@mui/material';
import { DateInput, TextInput, useFormContext } from 'framework/form';
import { DATE_FORMAT } from 'framework/utils';
import type { InvoiceDateFormItem } from './types';
import { useBillingRouteContext } from '../BillingRouteContext';
import { useNewProjectUrl } from 'domain/shared/newProject';

const UpdateInvoiceDatesContent = () => {
  const navigate = useNavigate();
  const { projectId } = useBillingRouteContext();
  const { getFinanceUrl } = useNewProjectUrl();
  const { data: formData } = useFormContext();

  const items: InvoiceDateFormItem[] = formData?.items ?? [];

  const handleCancel = () => {
    navigate(getFinanceUrl(projectId));
  };

  return (
    <UpdatePageLayout title="Update Invoice Dates" isCancelButtonVisible onCancelAction={handleCancel}>
      <Box sx={{ pt: 2, pl: 0 }}>
        {items.map((item, index) => (
          <Grid2 key={item.id} container spacing={2} columns={12} sx={{ mb: 2, alignItems: 'flex-start' }}>
            <Grid2 size={0.5}>
              <Box
                sx={{
                  padding: '7px',
                  border: '1px solid var(--mui-palette-border-default)',
                  borderRadius: '3px',
                  backgroundColor: 'var(--mui-palette-background-default)',
                  color: 'var(--mui-palette-text-secondary)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {item.position}
              </Box>
            </Grid2>
            <Grid2 size={4}>
              <TextInput source={`items.${index}.name`} label="Name" disabled />
            </Grid2>
            <Grid2 size={2}>
              <DateInput
                source={`items.${index}.invoiceDate`}
                label="Invoice date"
                dateFormat={DATE_FORMAT.API_ONLY_DATE}
              />
            </Grid2>
          </Grid2>
        ))}
        {items.length === 0 && (
          <Typography variant="body1" color="textSecondary" py={3}>
            No schedule items found.
          </Typography>
        )}
      </Box>
    </UpdatePageLayout>
  );
};

export default UpdateInvoiceDatesContent;
